module.exports = __webpack_public_path__ + "passion-a7008e68.webp";